/**
 * Normaliza o texto da resposta e recupera o ID da espécie escolhida.
 *
 * Regra de negócio: o n8n deve retornar `specie_id` separado, mas o frontend
 * também aceita os marcadores técnicos para manter compatibilidade com
 * respostas antigas ou parcialmente formatadas pelo modelo.
 *
 * @param {string} rawText - Texto bruto retornado pelo webhook
 * @param {number|string|null} explicitSpecieId - ID retornado fora do texto
 * @returns {{ text: string, specieId: number|null }} Resposta normalizada
 */
export const normalizeAiResponse = (rawText, explicitSpecieId = null) => {
  const text = String(rawText || "");
  const metadataMatch = text.match(
    /<METADATA>\s*(\{[\s\S]*?\})\s*<\/METADATA>/i
  );
  const legacyMatch = text.match(
    /(?:<|\()?SPECIE_ID\s*:\s*(\d+)(?:>|\))?/i
  );

  let metadataSpecieId = null;
  if (metadataMatch?.[1]) {
    try {
      metadataSpecieId = JSON.parse(metadataMatch[1])?.specie_id ?? null;
    } catch {
      metadataSpecieId = null;
    }
  }

  const specieIdCandidates = [
    explicitSpecieId,
    metadataSpecieId,
    legacyMatch?.[1],
  ];
  const specieId =
    specieIdCandidates
      .map((value) => Number(value))
      .find((value) => Number.isInteger(value) && value > 0) ?? null;

  const cleanText = text
    .replace(/<METADATA>[\s\S]*?<\/METADATA>/gi, "")
    .replace(/(?:<|\()?SPECIE_ID\s*:\s*\d+(?:>|\))?/gi, "")
    .replace(/[ \t]+([,.;:])/g, "$1")
    .replace(/\n{3,}/g, "\n\n")
    .trim();

  return { text: cleanText, specieId };
};
